import { baseSiteEndPoint, buildHeaders, getSellerID } from "./common";
import { authorizedFetch } from "./login";

export const apiGetVirtualAccountDetails = async () => {
  try {
    const response = await authorizedFetch(`${baseSiteEndPoint}/uniconta/seller/${getSellerID()}/virtualaccounts/${getSellerID()}/`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiListVirtualAccountEntries = async (page = 1, pageSize = 50, search = '') => {
  try {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
      ...(search && { search })
    });
    
    const response = await authorizedFetch(`${baseSiteEndPoint}/uniconta/seller/${getSellerID()}/virtualaccounts/${getSellerID()}/entries?${queryParams}`, {
      method: "GET",
      headers: buildHeaders(),
    });
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};

export const apiEntriesDownload = async (format) => {
  try {
    const acceptHeader =
      format === 'csv'
        ? 'text/csv'
        : 'application/vnd.ms-excel';

    const response = await authorizedFetch(
      `${baseSiteEndPoint}/uniconta/seller/${getSellerID()}/virtualaccounts/${getSellerID()}/entries/report/`,
      {
        method: 'GET',
        headers: {
          ...buildHeaders(),
          Accept: acceptHeader,
        },
      }
    );

    return response.blob();
  } catch (error) {
    throw error;
  }
};

export const apiCreateDepositLink = async (payload) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/uniconta/seller/${getSellerID()}/virtualaccounts/${getSellerID()}/deposit/`,
      {
        method: 'POST',
        headers: buildHeaders(),
        body: JSON.stringify(payload),
      }
    );
    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
};